module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app large"
  }, [_c('div', {
    attrs: {
      "id": "loadingAjax"
    }
  }), _vm._v(" "), _c('news-heading', [_vm._v("\n        Latest Story\n    ")]), _vm._v(" "), _c('news-main', {
    attrs: {
      "article": _vm.landingArticle
    }
  }), _vm._v(" "), _c('main', [_c('our-articles', {
    attrs: {
      "articles": _vm.articles,
      "loading": _vm.loading,
      "nextPage": _vm.nextPage,
      "finished": _vm.finished
    }
  })], 1), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('lazy-component', [_c('news-heading', {
    attrs: {
      "subtitle": true
    }
  }, [_vm._v("\n                Features\n            ")]), _vm._v(" "), _c('readmore', {
    attrs: {
      "news": false,
      "columns": 4,
      "amount": 24
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-width"
  }, [_c('lazy-component', [_c('other-news')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39bd6b3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/landing.vue
// module id = 172
// module chunks = 4